import { createDecorator } from '../../../../../platform/instantiation/common/instantiation.js';
const ITerminalQuickFixService = ( createDecorator('terminalQuickFixService'));
export { ITerminalQuickFixService };
